// Environment configuration
interface Config {
  API_BASE_URL: string;
  SIGNALR_HUB_URL: string;
  NESHAN_API_KEY: string;
  NESHAN_MAP_KEY: string;
  NESHAN_SDK_URL: string;
  NESHAN_CSS_URL: string;
}

// Development environment
const devConfig: Config = {
  API_BASE_URL: 'https://localhost:44370/api/B2C',
  SIGNALR_HUB_URL: 'https://localhost:44370/chathub',
  NESHAN_API_KEY: 'service.d82c56b997584773826fcbd25c6794b1',
  //NESHAN_MAP_KEY: 'web.74c1d4045cfd4ac9a55656bdb2590515',
  NESHAN_MAP_KEY:'web.e8ab738788584602bb803ba6340b64d8',
  NESHAN_SDK_URL: 'https://static.neshan.org/sdk/leaflet/v1.9.4/neshan-sdk/v1.0.8/index.js',
  NESHAN_CSS_URL: 'https://static.neshan.org/sdk/leaflet/v1.9.4/neshan-sdk/v1.0.8/index.css'
};

// Staging environment
const stagingConfig: Config = {
  API_BASE_URL: 'https://staging-api.vanaxi.com/api/B2C',
  SIGNALR_HUB_URL: 'https://staging-api.vanaxi.com/chathub',
  NESHAN_API_KEY: 'service.d82c56b997584773826fcbd25c6794b1',
  //NESHAN_MAP_KEY: 'web.74c1d4045cfd4ac9a55656bdb2590515',
  NESHAN_MAP_KEY:'web.e8ab738788584602bb803ba6340b64d8',
  NESHAN_SDK_URL: 'https://static.neshan.org/sdk/leaflet/v1.9.4/neshan-sdk/v1.0.8/index.js',
  NESHAN_CSS_URL: 'https://static.neshan.org/sdk/leaflet/v1.9.4/neshan-sdk/v1.0.8/index.css'
};

// Production environment
const prodConfig: Config = {
  API_BASE_URL: 'https://api.shahsaa.com/api/B2C',
  SIGNALR_HUB_URL: 'https://api.shahsaa.com/chathub',
  NESHAN_API_KEY: 'service.d82c56b997584773826fcbd25c6794b1',
  //NESHAN_MAP_KEY: 'web.74c1d4045cfd4ac9a55656bdb2590515',
  NESHAN_MAP_KEY:'web.e8ab738788584602bb803ba6340b64d8',
  NESHAN_SDK_URL: 'https://static.neshan.org/sdk/leaflet/v1.9.4/neshan-sdk/v1.0.8/index.js',
  NESHAN_CSS_URL: 'https://static.neshan.org/sdk/leaflet/v1.9.4/neshan-sdk/v1.0.8/index.css'
};

// Get current environment
const getEnvironment = (): string => {
  // Check for Vite environment variable first
  if (import.meta.env.VITE_ENV) {
    return import.meta.env.VITE_ENV;
  }
  
  // Check for Vite mode
  if (import.meta.env.MODE) {
    return import.meta.env.MODE;
  }
  
  // Default to development
  return 'development';
};

// Get configuration based on environment
const getConfig = (): Config => {
  const env = getEnvironment();
  
  switch (env) {
    case 'production':
      return prodConfig;
    case 'staging':
      return stagingConfig;
    case 'development':
    default:
      return devConfig;
  }
};

// Export the configuration
export const config = getConfig();

// Export individual values for convenience
export const {
  API_BASE_URL,
  SIGNALR_HUB_URL,
  NESHAN_API_KEY,
  NESHAN_MAP_KEY,
  NESHAN_SDK_URL,
  NESHAN_CSS_URL
} = config;

// Export the environment
export const ENVIRONMENT = getEnvironment();

// Export the full config object
export default config;
